'use strict';

module.exports = function isValidUserToken(userToken) {
  if (userToken === null) {
    return false;
  }
  return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/utils/isValidUserToken.js
// module id = 51
// module chunks = 0